/*
 * Angular 2 decorators and services
 */
import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appSetting } from "../../../../config/appSettings";
import { Router, NavigationEnd } from '@angular/router';
import { GigyaSessionService } from '../../services/gigya-session.service';
import { AuthService } from '../../services/auth.service';
import { AppHelperService } from '../../services/app-helper.service';
import { config } from 'config';
import { environment } from 'environments/environment';
import { MessageService } from '../../services/message.service';
import { ThemeService } from "libs-frontend-micro-base";
declare var gigya: any;

/*
 * App Component
 * Top Level Component
 */
@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './../../../scss/application.scss'
    ],
    // Dont show header for product/class view route/page
     templateUrl: './app.template.html',
})
export class App implements OnInit {
    showCookiesBanner = false;
    themeService;
    constructor(
        private translate: TranslateService, 
        private router: Router, 
        private gigyaSessionService: GigyaSessionService,
        private authService: AuthService,
        public appHelperService : AppHelperService,
        public messageService: MessageService    
    ) { 
        this.themeService = new ThemeService();
    }

    ngOnInit() {
        let lang = this.getLanguageBasedOnRole();
        if (lang == null || lang == undefined) lang = 'en';
        this.translate.use(lang);
        document.getElementsByTagName("html")[0].setAttribute("lang", lang);
        // This is done so that when route changes scroll should move to the top of the page.
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        if(!environment.isDesktopApp){
            // Show/ Hide Cookies banner 
            let cookiesAccepted = localStorage.getItem(appSetting.localStorage.cookiesAccepted);
            if (cookiesAccepted === 'true') {
                this.showCookiesBanner = false;
            } else {
                this.showCookiesBanner = true;
            }

            //Initialize onGigyaLoad observable when the angular app is started
            this.gigyaSessionService.createGigyaLoadObservable();
            // Handle invalid users sessions 
            this.gigyaSessionService.getGigyaLoadListener().subscribe(async(res)=>{ 
                this.authService.isGigyaLoaded = true; 
                await this.authService.checkGigyaAndServerSession(); 
            });
            // Binding Event for Listening Logout Event from Local Storage
            window.addEventListener("storage", (ev) => {
                if (ev.storageArea == localStorage && ev.key == appSetting.localStorage.userLoggedOut) {
                    if (localStorage.getItem(appSetting.localStorage.userLoggedOut))
                        localStorage.removeItem(appSetting.localStorage.userLoggedOut);
                    sessionStorage.removeItem(appSetting.sessionStorage.userAccount);
                    this.appHelperService.navigateToOnboardingApp(["home"]);
                }
            });
        }

        this.themeService.activateTheme();
    }

    acceptCookies() {
        this.showCookiesBanner = false;
        localStorage.setItem(appSetting.localStorage.cookiesAccepted, 'true');
        this.messageService.emit('cookieStatus', {
            "enabled" : false
        });

        // Set focus on the first focusable element after accepting cookies
        document.getElementById('imgbook').setAttribute('tabindex', '1');
        document.getElementById('imgbook').focus();
    }
    
    navigateToPrivacyLink(){
        window.open(config.onBoardingAppDomain + 'privacy', '_blank');
    }
    private getLanguageBasedOnRole(){
        let userData = this.authService.getUserData();
        if(!userData || userData.role == 'superadmin') {
            const loggedInUserRole = localStorage.getItem(appSetting.localStorage.loggedInUserRole);
            userData = {role: loggedInUserRole}
        }
        if(['teacher', 'admin', 'superadmin'].indexOf(userData.role) > -1 ) {
            return 'en';
        } 
        return localStorage.getItem(appSetting.localStorage.lang);
    }
}


